<template>
    <div>
        <v-data-table 
            :headers="headers" 
            :items="itemsPage.data" 
            :total-items="totalItems" 
            :loading="loading" 
            :pagination.sync="pagination"
            class="elevation-1" 
            
            >
            <template v-slot:items="props">
             
                <td>{{ props.item.persona.nombre }} {{ props.item.persona.apellido }}</td>
                <td class="text-xs-center">{{ props.item.persona.documento }}</td>

                <td >{{ props.item.persona.email }}</td>

                <td>{{ props.item.created_at ? formatDateTime(props.item.created_at) : '' }}</td>

                <td>{{ props.item.updated_at ? formatDate(props.item.updated_at) : '' }}</td>
                
                <td>
                    <v-icon @click.stop="abrirShowLink(props.item)" title="Ver" small>visibility</v-icon>

                    <v-icon v-if="!loadingItem[props.item.id]" @click.stop="confirmEnviarEmail(props.item)" title="Enviar Email" small>email</v-icon>
                    <v-progress-circular v-else indeterminate small color="primary"></v-progress-circular>

                </td>
            </template>
            <template slot="pageText" slot-scope="props">
            Personas pendiente de enviar desde {{ props.pageStart }} a {{ props.pageStop }} de {{
                props.itemsLength }}
        </template>
        </v-data-table>


        <v-dialog v-model="showLink" max-width="500">
            <v-card>
                <v-card-title class="headline">Link para subir apto</v-card-title>
                <v-card-text>
                    <p>{{ dialogText }}</p>
                    <a :href="dialogLink" target="_blank">{{ dialogLink }}</a>
                    <br/>
                    <v-btn color="primary" text small @click="copiarLink">Copiar Link</v-btn>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showLink = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import aptosMedicosApi from '../../../../../api/aptos';
import moment from 'moment';

export default {
    name: "ListaAptosMedicosTabla",
    props: {
        evento_id: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            loadingItem: {},
            dialogText: '',
            dialogLink: '',
            showDialog: false,
            showLink: false,
            totalItems: 0,   
            pagination: {
                descending: false,
                page: 1,
                rowsPerPage: 25,
                sortBy: "id",
                totalItems: 10
            },
            filters: {
                firstname: '',
                lastname: '',
                document: '',
                status: ''
            },
            loading: false,
            itemsPage: {
                data: [],
                total: 0,
            },
            headers: [
               
                { text: 'Nombre y apellido', value: 'nombre_completo', sortable: false, align: 'left' },
                { text: 'Documento', value: 'documento', sortable: false, align: 'center' },
                { text: 'Email', value: 'email', sortable: false, align: 'left' },
                { text: 'Token Creado', value: 'created_at', sortable: false, align: 'left' },
                 
                { text: 'Ult.actualizacion', value: 'updated_at', sortable: false, },
               
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        pagination: {
            handler() {
                console.log("PAGINATION", this.pagination);                 
                this.loadData();                    
            },
            deep: true,
        },
    },
    methods: {
        abrirShowLink(item) {
            this.dialogText = item.persona.nombre + ' ' + item.persona.apellido;
            this.dialogLink = item.link;
            this.showLink = true;
        },
        confirmEnviarEmail(item) {
            const confirm = window.confirm("¿Está seguro de que desea enviar el email a " + item.persona.nombre + ' ' + item.persona.apellido + " ("+item.persona.email+") ?");
            if (confirm) {
                this.enviarEmail(item);
            }
        },
        enviarEmail(item) {
            this.$set(this.loadingItem, item.id, true);
            aptosMedicosApi.enviarEmail(item.id, item.token)
            .then(response => {
                debugger;
                this.$set(this.loadingItem, item.id, false);
                if (response.email) {
                    this.$set(this.loadingItem, item.id, false);                    
                     alert("Email encolado para su envio a ("+response.email+") " + item.persona.nombre + ' ' + item.persona.apellido);
                } 
            })
            .catch(error => {
                this.$set(this.loadingItem, item.id, false);
                console.log("Error al enviar el email:", error);
            });
        },

        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('DD/MM/YYYY');
        },
        formatDateTime(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('DD/MM/YYYY HH:mm');
        },
        loadData() {
            this.loading = true;
            const params = {};

            if (this.filters.firstname) {
                params.firstname = this.filters.firstname;
            }
            if (this.filters.lastname) {
                params.lastname = this.filters.lastname;
            }
            if (this.filters.email) {
                params.email = this.filters.email;
            }


            if (this.filters.document) {
                params.document = this.filters.document;
            }
            if (this.filters.status) {
                params.status = this.filters.status;
            }
            if (this.pagination.page) {
                params.page = this.pagination.page;
            }

            aptosMedicosApi.getAptosNoEnviados(this.evento_id, params)
                .then(response => {
                    this.itemsPage = response;
                
                    this.totalItems = response.total;

                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.error("Error al cargar los aptos medicos:", error);
                });
        },
        applyFilters(filters) {
            this.filters = filters;
            this.loadData();
        },
      
        getColorEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'orange';
                case 'APPROVED':
                    return 'green';
                case 'REJECTED':
                    return 'red';
                default:
                    return 'grey';
            }
        },

        getNombreEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'Pendiente';
                case 'APPROVED':
                    return 'Aprobado';
                case 'REJECTED':
                    return 'Rechazado';
                default:
                    return 'Desconocido';
            }
        },

    
        updateFilters(filters) {
            this.filters = filters;
            this.loadData();
        },
        copiarLink() {
            navigator.clipboard.writeText(this.dialogLink)
                .then(() => {
                    alert("Link copiado al portapapeles");
                })
                .catch(err => {
                    console.error("Error al copiar el link:", err);
                });
        },
    },

}
</script>

<style scoped>
/* Component styles can be added here */
</style>
